import { scrollTo } from './ScrollLenis';
import Selects from '../libs/selects';

export default class AnchorsProjet {
    constructor() {
        this.blockSelector = '.block-single-projet';
        this.desktopContainer = document.querySelector('.grid_action-desktop');
        this.mobileContainer = document.querySelector('.grid_action-mobile');
        if (this.desktopContainer || this.mobileContainer) {
            window.addEventListener('DOMContentLoaded', () => this.init());
        }
    }

    slugify(text) {
        return text.toString().toLowerCase()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/--+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    ensureBlockAnchors() {
        document.querySelectorAll(this.blockSelector).forEach(section => {
            const uppertitle = section.querySelector('.uppertitle');
            if (uppertitle && !section.id) {
                section.id = this.slugify(uppertitle.textContent.trim());
            }
        });
    }

    getBlockAnchors() {
        const anchors = [];
        document.querySelectorAll(`${this.blockSelector}[id]`).forEach(section => {
            const uppertitle = section.querySelector('.uppertitle');
            if (uppertitle) {
                anchors.push({
                    id: section.id,
                    label: uppertitle.textContent.trim()
                });
            }
        });
        return anchors;
    }

    buildAnchorSelect(anchors) {
        if (!this.mobileContainer) return;
        this.mobileContainer.innerHTML = '';
        const select = document.createElement('select');
        select.className = 'js-block-anchors js-select';

        const placeholderOption = document.createElement('option');
        placeholderOption.value = 'placeholder';
        placeholderOption.textContent = 'Aller à…';
        placeholderOption.selected = true;

        select.appendChild(placeholderOption);

        anchors.forEach(anchor => {
            const option = document.createElement('option');
            option.value = '#' + anchor.id;
            option.textContent = anchor.label;
            select.appendChild(option);
        });
        this.mobileContainer.appendChild(select);

        new Selects('.js-select');
        const niceSelect = select.parentElement.querySelector('.nice-select');
        if (niceSelect && select.selectedIndex === 0) {
            niceSelect.querySelector('.current').textContent = 'Aller à…';
        }
    }

    buildAnchorLinks(anchors) {
        if (!this.desktopContainer) return;
        this.desktopContainer.innerHTML = '';
        const ul = document.createElement('ul');
        ul.className = 'block-anchors';
        anchors.forEach(anchor => {
            const li = document.createElement('li');
            li.className = 'block-anchors-item';
            const a = document.createElement('a');
            a.href = '#' + anchor.id;
            a.textContent = anchor.label;
            a.className = 'block-anchors-link';
            li.appendChild(a);
            ul.appendChild(li);
        });
        this.desktopContainer.appendChild(ul);
    }

    scrollToAnchor(selector) {
        const section = document.querySelector(selector);
        if (section) {
            scrollTo(section, {
                offset: 0,
                duration: 1.2,
            });
        }
    }

    setupAnchorNavigation() {
        document.addEventListener('click', (e) => {
            if (e.target.matches('.block-anchors-link')) {
                e.preventDefault();
                const id = e.target.getAttribute('href');
                this.scrollToAnchor(id);
            }
        });
        document.addEventListener('change', (e) => {
            if (e.target.matches('.js-block-anchors')) {
                const val = e.target.value;
                if (val === 'placeholder') return;
                if (val && document.querySelector(val)) {
                    this.scrollToAnchor(val);
                }
            }
        });
    }

    scrollSpy(anchors) {
        if (!anchors.length) return;
        const sections = anchors.map(a => document.getElementById(a.id));
        const links = document.querySelectorAll('.block-anchors-link');
        const select = document.querySelector('.js-block-anchors');

        function onScroll() {
            const scrollPos = window.scrollY + window.innerHeight / 4;
            let current = null;
            for (let i = sections.length - 1; i >= 0; i--) {
                if (sections[i] && sections[i].offsetTop <= scrollPos) {
                    current = anchors[i].id;
                    break;
                }
            }
            links.forEach(link => {
                const isActive = link.getAttribute('href') === '#' + current;
                link.classList.toggle('is-active', isActive);

                if (link.parentElement) {
                    link.parentElement.classList.toggle('is-active', isActive);
                }
            });
            if (select) {
                Array.from(select.options).forEach(option => {
                    option.selected = option.value === '#' + current;
                });
                if (typeof NiceSelect !== "undefined") {
                    NiceSelect.update(select);
                }
            }
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
    }


    init() {
        this.ensureBlockAnchors();
        const anchors = this.getBlockAnchors();
        this.buildAnchorSelect(anchors);
        this.buildAnchorLinks(anchors);
        this.setupAnchorNavigation();
        this.scrollSpy(anchors);
    }
}
